export const uk = {
    all_day: 'круглосуточно',
    friday: 'ПТ',
    monday: 'ПН',
    saturday: 'СБ',
    sunday: 'ВС',
    thursday: 'ЧТ',
    tuesday: 'ВТ',
    wednesday: 'СР',
    weekends: 'выходные',
    working_days: 'рабочие дни'
};
